module.exports = __webpack_public_path__ + "img/play-btn.cec6c849.png";